import { useHistory } from 'react-router-dom';
import { useReducer } from 'react';
import constate from 'constate';
import createReducer from 'helpers/reducers-helper';
import assign from 'lodash/assign';
import {
  useAppContext,
  UPDATE_USER_INFO,
  SHOW_APP_MESSAGE,
  NOW_SETTING_CREDIT_CARD,
  NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD,
} from 'use-app';
import repo from 'service/repository';
import { errorHandler } from 'helpers/error-handler';
import { getCpcId } from 'service/local-data-provider';

export const INITIALIZE = 'initialize';
export const CHANGE_SWITCH_STATE = 'change_switch_state';
export const CHANGE_SWITCH_CHECKED = 'change_switch_cheecked';
export const CHANGE_REMOVE_DIALOG_SHOW = 'change_remove_dialog_show';
export const CHANGE_UPDATE_DIALOG_SHOW = 'change_update_dialog_show';
export const SHOW_LOADING = 'show_loading';
export const HIDE_LOADING = 'hide_loading';

const useMochiPayFlow = () => {
  const { state: appState, dispatch: appDispatch } = useAppContext();
  const history = useHistory();
  const initState = {
    state: 'default',
    switchState: 'off',
    switchChecked: false,
    defaultDistributor: false,
    currentCreditCard: null,
    removeDialogShow: false,
    updateDialogShow: false,
    loading: false,
    customerServiceDialog: false,
  };

  const changeSwitchState = (state, payload) => assign({}, state, { switchState: payload });
  const changeSwitchChecked = (state, payload) => assign({}, state, { switchChecked: payload });
  const changeRemoveDialogShow = (state, payload) => assign({}, state, { removeDialogShow: payload });
  const changeUpdateDialogShow = (state, payload) => assign({}, state, { updateDialogShow: payload });
  const showLoading = state => assign({}, state, { loading: true });
  const hideLoading = state => assign({}, state, { loading: false });

  const initialize = () => {
    const isDefaultDistributor = appState.me ? appState.me.defaultDistributor : false;
    const currentCreditCard = appState.me ? appState.me.currentCreditCard : null;
    let initializeState = {
      state: 'default',
      switchState: 'off',
      switchChecked: false,
      defaultDistributor: isDefaultDistributor,
      currentCreditCard: currentCreditCard,
      loading: false,
    };

    if (currentCreditCard) {
      if (isDefaultDistributor) {
        if (currentCreditCard.lastPaymentSuccess) {
          initializeState = assign({}, initializeState, {
            state: 'default-distributor',
            switchState: 'on',
            switchChecked: true,
          });
        } else {
          initializeState = assign({}, initializeState, {
            state: 'last-payment-fail',
            switchState: 'alert',
            switchChecked: true,
          });
        }
      } else {
        initializeState = assign({}, initializeState, {
          state: 'not-default-distributer',
          switchState: 'alert',
          switchChecked: true,
        });
      }
    } else {
      initializeState = assign({}, initializeState, {
        state: 'default',
      });
    }

    return assign({}, initState, initializeState);
  };

  const updateDefaultDistributor = () => {
    dispatch({ type: CHANGE_UPDATE_DIALOG_SHOW, payload: false });
    repo
      .updateUserInfo(undefined, undefined, undefined, undefined, true)
      .then(repo.fetchUserInfo)
      .then(data => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: data,
        });
        dispatch({ type: INITIALIZE });
      })
      .catch(error => {
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'failure',
            message: errorHandler(error),
          },
        });
      });
  };

  const createWallet = () => {
    repo
      .bindCpcPay(getCpcId())
      .then(() => {
        if (
          (appState.nowSettingCreditCard || appState.nowSettingLicensePlateAndCreditCard) &&
          appState.setFrom === 'autopay'
        ) {
          return repo.updateUserInfo(undefined, undefined, undefined, true);
        } else {
          return repo.fetchUserInfo();
        }
      })
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        appDispatch({
          type: NOW_SETTING_CREDIT_CARD,
          payload: false,
        });
        appDispatch({
          type: NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD,
          payload: false,
        });
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'success',
            message: '綁定成功',
          },
        });
      })
      .catch(error => {
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'failure',
            message: errorHandler(error),
          },
        });
      })
      .finally(() => {
        history.goBack();
      });
  };

  const removeWallet = () => {
    repo
      .deleteCreditCard()
      .then(repo.fetchUserInfo)
      .then(data => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: data,
        });
        dispatch({ type: INITIALIZE });
      })
      .catch(error => {
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'failure',
            message: errorHandler(error),
          },
        });
      });
  };

  const reducer = createReducer(
    {
      [INITIALIZE]: initialize,
      [CHANGE_SWITCH_STATE]: changeSwitchState,
      [CHANGE_SWITCH_CHECKED]: changeSwitchChecked,
      [CHANGE_REMOVE_DIALOG_SHOW]: changeRemoveDialogShow,
      [CHANGE_UPDATE_DIALOG_SHOW]: changeUpdateDialogShow,
      [SHOW_LOADING]: showLoading,
      [HIDE_LOADING]: hideLoading,
    },
    initState,
    true
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch, updateDefaultDistributor, createWallet, removeWallet };
};

const [MochipayFlowProvider, useMochiPayFlowContext] = constate(useMochiPayFlow);
export { MochipayFlowProvider, useMochiPayFlowContext };
